import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import { EventName, RemoteCommandType } from '@/utils/constant';
import { debounce } from '@/utils/util';
import {
  addGlobalEventListener,
  removeGlobalEventListener,
} from '@/utils/emit';
import BussinessApi from '@/fetch/bussiness';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import { message } from 'antd';

const btnList = [
  {
    type: 'gear-D',
    ico: require('@/assets/images/monitor/d.png'),
    activeIco: require('@/assets/images/monitor/active-drive.png'),
    value: 'D',
  },
  {
    type: 'gear-N',
    ico: require('@/assets/images/monitor/n.png'),
    activeIco: require('@/assets/images/monitor/active-n.png'),
    value: 'N',
  },
  {
    type: 'gear-R',
    ico: require('@/assets/images/monitor/r.png'),
    activeIco: require('@/assets/images/monitor/active-r.png'),
    value: 'R',
  },
  {
    type: 'gear-P',
    ico: require('@/assets/images/monitor/p.png'),
    activeIco: require('@/assets/images/monitor/active-p.png'),
    value: 'P',
  },
];

const requestApi = new BussinessApi();

const gearList = ['D', 'N', 'R', 'P'];

const gearCommand = [
  RemoteCommandType.GEAR_DRIVE,
  RemoteCommandType.GEAR_NEUTRAL,
  RemoteCommandType.GEAR_REVERSE,
  RemoteCommandType.GEAR_PARK,
];

const GearPosition = (props: {
  value: string;
  vehicleName: string;
  sendRemoteCommand: (type: RemoteCommandType) => void;
  takeOverBySelf: boolean;
  LC_BUTTON_L1: boolean;
  LC_BUTTON_SQUARE: boolean;
  LC_BUTTON_CIRCLE: boolean;
  LC_BUTTON_R1: boolean;
  newTakeover: boolean;
}) => {
  const {
    takeOverBySelf,
    LC_BUTTON_L1,
    LC_BUTTON_SQUARE,
    LC_BUTTON_CIRCLE,
    LC_BUTTON_R1,
    newTakeover,
    vehicleName,
  } = props;
  const initGearPos = useRef<string>(props.value);
  const superControl = useRef<boolean>(false);
  const cockpitNumber = useSelector(
    (state: RootState) => state.newCommon?.cockpitNumber
  );
  const userName = useSelector(
    (state: RootState) => state.login?.userInfo?.userName
  );

  useEffect(() => {
    const cb = () => {
      initGearPos.current = 'P';
    };
    addGlobalEventListener(EventName.CHANGE_GEAR_POSITION, cb);
    return () => {
      removeGlobalEventListener(EventName.CHANGE_GEAR_POSITION, cb);
    };
  }, []);

  const changeGearPosition = () => {
    let selectedIndex: number | null = null;
    if (initGearPos.current) {
      const index = gearList.indexOf(initGearPos.current);
      if (index > 3) {
        selectedIndex = 0;
      } else {
        selectedIndex = index + 1;
      }
    } else {
      selectedIndex = 0;
    }
    if (selectedIndex > 3) {
      selectedIndex = 0;
    }
    initGearPos.current = gearList[selectedIndex];
    props.sendRemoteCommand(gearCommand[selectedIndex!]);
  };

  const sendParkCommand = () => {
    props.sendRemoteCommand(RemoteCommandType.GEAR_PARK);
  };

  const sendDriveGearPos = () => {
    props.sendRemoteCommand(RemoteCommandType.GEAR_DRIVE);
    if (!newTakeover) {
      initGearPos.current = 'D';
    }
  };

  const sendReverseGearPos = () => {
    props.sendRemoteCommand(RemoteCommandType.GEAR_REVERSE);
    if (!newTakeover) {
      initGearPos.current = 'R';
    }
  };

  const sendSuperControlGearOn = async () => {
    const res1 = await requestApi.buttonCommand({
      cockpitNumber: cockpitNumber,
      vehicleName: vehicleName,
      cockpitUserName: userName,
      remoteCommandType: RemoteCommandType.SUPER_MODE_ON,
    });
    if (res1.code !== HttpStatusCode.Success) {
      message.error(res1?.message || '指令下发失败');
      return;
    }
    const res2 = await request({
      path: '/monitor/web/drive/command/send/velocity-control',
      method: 'POST',
      body: {
        vehicleName: vehicleName,
        cockpitNumber: cockpitNumber,
        cockpitUserName: userName,
        data: Math.floor((5 / 3.6) * 100) / 100,
      },
    });
    if (res2.code === HttpStatusCode.Success) {
      message.success('指令下发成功');
    } else {
      message.error(res2?.message || '指令下发失败');
    }
  };

  const sendSuperControlGearOff = () => {
    props.sendRemoteCommand(RemoteCommandType.SUPER_MODE_OFF);
  };

  useEffect(() => {
    if (takeOverBySelf && LC_BUTTON_L1) {
      if (newTakeover) {
        debounce(sendParkCommand, 500)();
      } else {
        debounce(changeGearPosition, 500)();
      }
    }
  }, [takeOverBySelf, LC_BUTTON_L1]);

  useEffect(() => {
    if (LC_BUTTON_SQUARE && takeOverBySelf) {
      debounce(sendDriveGearPos, 500)();
    }
  }, [takeOverBySelf, LC_BUTTON_SQUARE]);

  useEffect(() => {
    if (takeOverBySelf && LC_BUTTON_CIRCLE) {
      debounce(sendReverseGearPos, 500)();
    }
  }, [takeOverBySelf, LC_BUTTON_CIRCLE]);

  // 右拨片强制遥控
  useEffect(() => {
    if (!takeOverBySelf) {
      return;
    }
    // 按一次右拨片强制遥控开启，再按一次强制遥控关闭
    if (LC_BUTTON_R1 == true) {
      superControl.current = !superControl.current;
      if (superControl.current) {
        debounce(sendSuperControlGearOn, 500)();
      } else {
        debounce(sendSuperControlGearOff, 500)();
      }
    }
  }, [LC_BUTTON_R1, takeOverBySelf]);

  return (
    <div className="gear-container">
      {btnList.map((i) => {
        const imgUrl = takeOverBySelf
          ? props.value === i.value
            ? i.activeIco
            : i.ico
          : i.ico;
        return <img src={imgUrl} className={i.type} key={i.type} />;
      })}
    </div>
  );
};

export default React.memo(GearPosition);
